// ! ||--------------------------------------------------------------------------------||
// ! ||                                   PDP Offers                                   ||
// ! ||--------------------------------------------------------------------------------||

class ExtendProductOffer extends HTMLElement {
    constructor(opts) {
        super();
        
        try {
            this.productForm =  document.querySelector(opts.productForm);
        } catch (err) {
            this.productForm = opts.productForm;
        }
        
        try {
            this.addToCartButton = document.querySelector(opts.addToCartButton);
        } catch (err) {
            this.addToCartButton = opts.addToCartButton;
        }
        
        const referenceId = opts.referenceId || opts.productForm.id.value;
        const price = opts.price || meta.product.variants.filter(variant => variant.id == referenceId)[0].price;
        const category = opts.category || meta.product.type;
        
        this.params = {
            referenceId,
            price,
            category
        };
        
        this.config = getConfiguration();
        this.config.dispatchSideCart = false;
        
    }
    
    connectedCallback() {
        try {
            this.verifyProductOffer();
        } catch (err) {
            console.error(err.message);
            return;
        }
        
        this.bindEvents();
        this.style.display = 'block';
        
        if (!this.config.pdpOfferEnabled) this.style.display = 'none';
        // Renders Extend offer
        Extend.buttons.render(this, this.params, () => {
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 250);
        });
    }
    
    bindEvents() {
        this.handleAddToCart = this.handleAddToCart.bind(this);
        this.addToCartButton.addEventListener('click', this.handleAddToCart, true);
        
        document.addEventListener('product:variant-change', this.handleVariantChange.bind(this), true);
    }
    
    verifyProductOffer() {
        
        let elementsToCheck = [
            'this.productForm',
            'this.addToCartButton',
            'this.params.referenceId',
            'this.params.price',
            'this.params.category'
        ]
        
        let missingProperties = elementsToCheck.filter((value) => {
            try {
                return !eval(value);
            } catch (err) {
                return true;
            }
        });
        
        if (missingProperties.length) {
            let message = "The following value(s) are null or undefined:\n";
            missingProperties.forEach((value) => {
                message += `\t${value}\n`;
            });
            throw new ExtendError(message);
        }
        
        // Checks if Extend lives in the window and the active currency is USD before showing Extend offers
        verifyExtend();
    }
    
    modalDone() {
        // remove default click listener
        this.addToCartButton.removeEventListener('click', this.handleAddToCart, true);
        // click atc button
        this.addToCartButton.click();
        // add default click listener back
        this.addToCartButton.addEventListener('click', this.handleAddToCart, true);
        
        // If variable set to true, dispatches Extend side cart integration to run after adding to cart via pdp
        if (this.config.dispatchSideCart) window.setTimeout(() => {
            initCartOffer();
        }, 500);
    }
    
    /**
    * Handle add to cart event with offers
    * @param {PointerEvent} e Click event from Add To Cart Button
    */
    handleAddToCart(e) {
        const sizeSelectInput = document.querySelector('.size-select input');
        if (!sizeSelectInput || sizeSelectInput.value.trim() !== '') {
            e.preventDefault();
            e.stopImmediatePropagation();
            
            const quantityEl = this.productForm.querySelector('[name="quantity"]');
            const quantity = quantityEl && quantityEl.value ? quantityEl.value : 1;
            
            ExtendShopify.handleAddToCart(this, {
                quantity: quantity,
                modal: this.config.modalOfferEnabled || this.config.quickViewModalOfferEnabled,
                done: this.modalDone.bind(this)
            });
        }
    }
    
    handleVariantChange(e) {
        this.params.referenceId = e.detail.variant.id;
        this.params.price = e.detail.variant.price;
        
        
        Extend.setActiveProduct(this, this.params);
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 250);
    }
}
if (!customElements.get('extend-offer'))
    customElements.define('extend-offer', ExtendProductOffer);

/**
* Initializes product offers and handles ATC button functionality for the main PDP ATC
*/
function initProductOffer() {
    try {
        if ((meta.page.pageType != 'product' || !meta.product))
            throw new ExtendError("Extend Product Offer - The current page is not a product page");
    } catch (err) {
        console.warn(err.message);
        return;
    }
    
    const productFormSelector = 'product-form form[action="/cart/add"]';
    const addToCartButtonSelector = 'button[name="add"]';
    
    const productForm = document.querySelector(productFormSelector);
    const addToCartButton = productForm ? productForm.querySelector(addToCartButtonSelector) : document.querySelector(addToCartButtonSelector);
    // Create offer and render it
    const extendOffer = new ExtendProductOffer({productForm, addToCartButton});
    
    productForm.prepend(extendOffer);
}

// ! ||--------------------------------------------------------------------------------||
// ! ||                                Quickview Offers                                ||
// ! ||--------------------------------------------------------------------------------||
const initQuickView = (() => {
    
    const quickViewSelectors = {
        quickViewButton: 'quick-view',
        quickViewModal: '#Product-Drawer-Content',
        productForm: 'product-form form[action="/cart/add"]',
        addToCartButton: 'button[name="add"]'
    };
    
    async function handleQuickViewOpen(e) {
        const quickViewModal = document.querySelector(quickViewSelectors.quickViewModal);
        const productForm = quickViewModal.querySelector(quickViewSelectors.productForm);
        const addToCartButton = productForm.querySelector(quickViewSelectors.addToCartButton);
        
        // ! ||--------------------------------------------------------------------------------||
        // ! ||                 Determine referenceId, price, and category here                ||
        // ! ||--------------------------------------------------------------------------------||
        
        const referenceId = productForm.id.value;
        
        const params = {};
        if (meta.product) {
            let product = meta.products.filter((product) => product.variants[0].id == referenceId)[0];
            params.price = product.variants[0].price
            params.category = product.type
        } else {
            let product = await fetchProduct(e.detail.productHandle)
            params.price = (parseFloat(product.variants[0].price) * 100).toFixed(0)
            params.category = product.product_type
        }
        
        let offer = new ExtendProductOffer({ referenceId, productForm, addToCartButton, ...params });
        addToCartButton.parentElement.before(offer);
    }
    
    return function init() {
        const quickViewButtons = document.querySelectorAll(quickViewSelectors.quickViewButton);
        
        if (quickViewButtons.length == 0) throw new ExtendError(`No quickview buttons found on page with selector: ${quickViewSelectors.quickViewButton}`);
        
        document.addEventListener('quick-view:open', handleQuickViewOpen);
    }
})()

// ! ||--------------------------------------------------------------------------------||
// ! ||                                   Cart Offers                                  ||
// ! ||--------------------------------------------------------------------------------||
const cartOfferTag = 'extend-cart-offer';
class ExtendCartOffer extends HTMLElement {
    
    constructor(referenceId, category, price, quantity, type) {
        super();
        this.params = {
            referenceId,
            category,
            price,
            quantity
        }
        this.type = type;
        
        this.config = getConfiguration();
    }
    
    connectedCallback() {
        if (!this.canDisplayOffer()) {
            return;
        }
        
        Extend.buttons.renderSimpleOffer(this, {
            referenceId: this.params.referenceId,
            price: this.params.price,
            category: this.params.category,
            onAddToCart: ({ plan, product }) => {
                ExtendShopify.addPlanToCart({
                    plan,
                    product,
                    quantity: this.params.quantity
                }, (err) => {
                    if (err) {
                        throw new ExtendError(err.message);
                    }
                    
                    document.dispatchEvent(new Event('extend.plan-added'));
                });
            }
        });
    }
    
    canDisplayOffer() {
        return (this.type === 'main' && this.config.cartOfferEnabled) || (this.type === 'side' && this.config.sideCartOfferEnabled);
    }
}
if (!customElements.get(cartOfferTag))
    customElements.define(cartOfferTag, ExtendCartOffer);

class ExtendCheckoutPlus {
    static getQuote(cart) {
        return new Promise(resolve => {
            const mappedItems = ExtendShopify.spCartMapper(cart.items);
            
            window.Extend.shippingProtection.getUpdatedSPQuote({
                items: mappedItems,
                onUpdate: ({ quote }) => {
                    return resolve(quote)
                },
            })
        })
    }
    
    static formatPrice(quote) {
        return (quote / 100).toFixed(2);
    }
    
    static setShippingProtectionAttribute(selectedOrDeclined) {
        if (selectedOrDeclined !== 'selected' && selectedOrDeclined !== 'declined') {
            throw new ExtendError(`Parameter value must be "selected" or "declined", was ${selectedOrDeclined}`);
        }
        
        getCart()
        .then(cart => {
            // Add or update the attributes
            const updatedAttributes = {
                ...cart.attributes,
                'Extend Shipping Protection': selectedOrDeclined
            };
            
            return fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    attributes: updatedAttributes
                })
            });
        })
        .then(response => response.json())
        .then((updatedCart) => {
            
            if (!updatedCart.attributes['Extend Shipping Protection']) {
                throw new ExtendError('Shipping Protection attribute not found on checkout plus cart');
            }
            
            window.location.href = '/checkout';
        })
        .catch(error => {
            console.error('Error updating cart:', error);
        });
    }
    
    static destroy() {
        document.querySelectorAll('extend-checkout-plus').forEach((each) => each.remove());
    }
}

class ExtendCheckoutPlusOffer extends HTMLElement{
    constructor(defaultCheckoutButton, cart, quote) {
        super();
        this.defaultCheckoutButton = defaultCheckoutButton;
        
        this.cart = cart;
        this.currentQuote = quote;
    }
    
    connectedCallback() {
        this.innerHTML = this.getOfferMarkup();
        
        const checkoutPlusButton = this.defaultCheckoutButton.cloneNode();
        checkoutPlusButton.classList.remove('checkout-button');
        checkoutPlusButton.classList.add('extend-checkout-plus-button');
        
        checkoutPlusButton.removeAttribute('name');
        checkoutPlusButton.removeAttribute('type');
        
        checkoutPlusButton.setAttribute('title', 'Checkout with Extend Checkout+');
        
        this.append(checkoutPlusButton);
        
        this.checkoutPlusButton = checkoutPlusButton;
        this.setCheckoutPlusButtonText();
        
        this.defaultCheckoutButton.innerHTML = `<span>Continue without Checkout+ <b>•</b> \$${ExtendCheckoutPlus.formatPrice(this.cart.items_subtotal_price)}</span>`;
        this.defaultCheckoutButton.setAttribute('title', 'Checkout without Extend Checkout+');
        this.defaultCheckoutButton.classList.add('outline');
        this.defaultCheckoutButton.classList.add('checkout-no-sp');
        
        this.bindEvents();
    }
    
    diconnectedCallback() {
        this.defaultCheckoutButton.innerHTML = `<span>Checkout <b>•</b> \$${ExtendCheckoutPlus.formatPrice(this.cart.items_subtotal_price)}</span>`;
        this.defaultCheckoutButton.setAttribute('title', 'Checkout');
        this.defaultCheckoutButton.classList.remove('outline');
        this.defaultCheckoutButton.classList.remove('checkout-no-sp');
    }
    
    bindEvents() {
        this.defaultCheckoutButton.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            
            ExtendCheckoutPlus.setShippingProtectionAttribute('declined');
        }.bind(this));
        
        this.checkoutPlusButton.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            
            ExtendCheckoutPlus.setShippingProtectionAttribute('selected');
        }.bind(this));
        
        this.querySelector('.checkout-plus-info-icon').addEventListener('click', () => {
            Extend.shippingProtection.modal.open();
        });
    }
    
    setCheckoutPlusButtonText() {
        if (!this.checkoutPlusButton) {
            throw new ExtendError('No checkout plus button to set text');
        }
        
        this.checkoutPlusButton.innerHTML = `<span> Checkout+ <b>•</b> \$${ExtendCheckoutPlus.formatPrice(this.cart.items_subtotal_price + this.currentQuote.premium)} <span style="opacity: 0.7;">(+\$${ExtendCheckoutPlus.formatPrice(this.currentQuote.premium)})</span></span>`;
    }
    
    getOfferMarkup() {
        return `<div class="checkout-plus-container" style="padding-left: 20px !important; padding-right: 20px !important;"><div class="checkout-plus-image"><div class="checkout-plus-icon-row"><span class="checkout-plus-package-icon">
                    <svg viewBox="0 0 32 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.86368 2.89709C6.3014 4.04539 3.32139 5.37654 2.2414 5.85423C0.866067 6.45876 0.239466 6.76369 0.142615 6.86533L0 7.01261V13.4701C0 18.998 0.0101108 19.943 0.0713075 20.0648C0.13756 20.1869 0.99325 20.5882 6.79045 23.1844C10.4428 24.8255 13.4942 26.167 13.5705 26.167C13.6519 26.167 13.9933 26.0298 14.3347 25.8671C23.56 21.3604 25.8625 20.2121 25.9541 20.0953C26.056 19.9632 26.056 19.8719 26.0711 13.5259C26.0813 7.4696 26.0762 7.07843 25.9948 6.94123C25.9184 6.82446 24.8129 6.26052 19.8666 3.82672C16.5455 2.19595 13.7642 0.84437 13.6775 0.834021C13.5604 0.818893 12.506 1.2711 8.86368 2.89709ZM18.9345 4.57881C21.8433 6.00656 24.2323 7.18511 24.2427 7.19546C24.2733 7.22598 19.6173 9.50215 19.5308 9.50215C19.4544 9.50215 8.5734 4.35536 8.51247 4.28928C8.4973 4.26884 8.50741 4.24867 8.53296 4.23328C8.56355 4.2232 9.7098 3.71499 11.0801 3.10037C12.4554 2.48548 13.5915 1.98259 13.6118 1.98259C13.6317 1.98232 16.0309 3.15106 18.9345 4.57881ZM12.4397 7.37327C15.333 8.75006 17.8293 9.93392 17.9921 10.0101L18.2773 10.1473L15.9189 11.3006L13.5655 12.459L7.74804 9.85245C4.5541 8.41462 1.93568 7.23075 1.93568 7.21032C1.93568 7.17476 7.02459 4.88851 7.11638 4.88346C7.15204 4.87842 9.54616 6.00125 12.4397 7.37327ZM7.03497 10.7417L12.9644 13.399L12.9796 19.0742C12.9846 22.1937 12.9745 24.7443 12.954 24.7443C12.9285 24.7443 10.2491 23.5503 6.99399 22.0921L1.06988 19.4348V13.7546C1.06988 10.6351 1.07493 8.07944 1.08505 8.07944C1.09516 8.07944 3.76945 9.27843 7.03497 10.7417ZM24.9504 13.8003L24.9353 19.4704L19.5457 22.1075C16.5758 23.5554 14.141 24.7446 14.1309 24.7446C14.1208 24.7446 14.1154 22.194 14.1208 19.0744L14.1359 13.4043L19.5101 10.7723C22.4645 9.32434 24.8996 8.13544 24.9249 8.13544C24.9454 8.13013 24.9558 10.6807 24.9504 13.8003Z" fill="black"></path>
                        <path d="M2.59274 10.6663C2.47567 10.7881 2.44507 10.8595 2.44507 11.0373C2.44507 11.1645 2.48578 11.3017 2.53686 11.3677C2.66937 11.5405 5.63395 12.9223 5.86836 12.9276C6.0924 12.9327 6.34197 12.7244 6.38295 12.511C6.41355 12.3483 6.3167 12.0994 6.18419 11.9877C6.12805 11.9471 5.42003 11.5965 4.6101 11.2154C2.95939 10.4376 2.85243 10.4121 2.59274 10.6663Z" fill="black"></path>
                        <path d="M2.7263 12.712C2.43096 12.8694 2.34422 13.2964 2.5632 13.535C2.70076 13.6926 5.66029 15.0898 5.85399 15.0898C6.06286 15.0898 6.30738 14.912 6.3582 14.7239C6.40902 14.5256 6.35314 14.2921 6.23075 14.17C6.09346 14.0381 3.09801 12.651 2.95539 12.651C2.88409 12.651 2.78218 12.6815 2.7263 12.712Z" fill="black"></path>
                        <path d="M27.4631 13.5371C29.2256 14.6578 30.718 15.1198 31.9172 15.0098L32.6096 14.9463L32.6438 15.6406C32.7711 18.2224 32.3627 20.3419 31.4495 21.9971C30.53 23.6634 29.1258 24.8096 27.3606 25.4766L27.1282 25.5645L26.8958 25.4785C25.1855 24.8523 23.8006 23.7589 22.8743 22.0977C21.956 20.4506 21.5152 18.2952 21.5862 15.5811L21.6038 14.8965L22.2874 14.9326C23.8073 15.0124 25.267 14.6873 26.6956 13.5742L27.0667 13.2852L27.4631 13.5371Z" fill="black" stroke="white" stroke-width="1.33333"></path>
                    </svg>
                    </span></div></div><div class="checkout-plus-info-container"><div class="checkout-plus-top-row"><div class="checkout-plus-title-icon-container"><span class="checkout-plus-title">Extend Checkout+
                        <svg class="checkout-plus-info-icon" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 0.318359C10.6903 0.318359 13.6816 3.30973 13.6816 7C13.6816 10.6903 10.6903 13.6816 7 13.6816C3.30973 13.6816 0.318359 10.6903 0.318359 7C0.318359 3.30973 3.30973 0.318359 7 0.318359Z" stroke="black" stroke-width="0.636364"></path>
                        <path d="M7.58743 4.35647H6.41261V3.18164H7.58743V4.35647ZM7.58743 9.64318V5.53129H5.8252V6.70612H6.41261V9.64318H5.8252V10.818H8.17485V9.64318H7.58743Z" fill="black"></path>
                        </svg>
                    </span></div></div><span class="checkout-plus-subtext">Added protection against loss, theft, or damage</span></div></div>`;
    }
    
    async update(cart) {
        const quote = await ExtendCheckoutPlus.getQuote(cart);
        this.cart = cart;
        
        if (quote && quote.premium > 0) {
            this.currentQuote = quote;
            
            this.setCheckoutPlusButtonText();
        } else {
            ExtendCheckoutPlus.destroy();
        }
    }
}
if (!customElements.get('extend-checkout-plus'))
    customElements.define('extend-checkout-plus', ExtendCheckoutPlusOffer);


const initCartOffer = (() => {
    var cart;
    var isInit = false;
    
    const {
        cartOfferEnabled,
        cartSPEnabled,
        sideCartOfferEnabled,
        cartBalancingEnabled,
        SPEnabled
    } = getConfiguration();
    
    const isMobile = screen.width < 1068;
    
    let type, cartSelectors;
    if (meta.page.pageType === 'cart' && (cartOfferEnabled || cartSPEnabled)) {
        cartSelectors = {
            cartContainer: '.cart-items tbody',
            cartRowItem: 'tr', // Container element for each item in the cart
            cartRowItemImage: '.product-cart-item-image img', // Product image or image anchor element
            cartRowItemTitle: '.cart-product-link', // Title anchor element for the product
            cartRowItemQuantity: 'input[name="updates[]"]', // Input element containing the product quantity
            warrantyOriginalMeta: '.product-cart-item-options', // Each warranty metadata item we want to remove.
            offerAnchor: '.product-cart-item div:last-child', // Container where the offer will be appended
            metadataContainer: 'ul', // Where warranty metadata will be appended (Product and Term)
            quantityWrapper: (isMobile ? '.product-cart-item' : '.product-quantity') + ' quantity-selector', // Wrapper for quantity input and buttons
            lineItemRemove: (isMobile ? '.product-cart-item' : '.product-quantity') + ' a.remove'
        }
        type = 'main';
    } else if (sideCartOfferEnabled) {
        cartSelectors = {
            cartContainer: '.product-cart-item--container',
            cartRowItem: '.product-cart-item', // Container element for each item in the cart
            cartRowItemImage: '.product-cart-item-image img', // Product image or image anchor element
            cartRowItemTitle: '.cart-product-link', // Title anchor element for the product
            cartRowItemQuantity: 'input[name="updates[]"]', // Input element containing the product quantity
            warrantyOriginalMeta: '.product-cart-item-options', // Each warranty metadata item we want to remove.
            offerAnchor: '.product-cart-item-info', // Container where the offer will be appended
            metadataContainer: 'ul', // Where warranty metadata will be appended (Product and Term)
            quantityWrapper: 'quantity-selector', // Wrapper for quantity input and buttons
            lineItemRemove: 'a.remove'
        }
        type = 'side';
    }
    
    if (type === undefined || cartSelectors === undefined) {
        throw new ExtendError('No cart type detected');
    }
    
    function createWarrantyOffer(lineItemElement, index) {
        if (!cartOfferEnabled) return;
        
        let cartItem = cart.items[index];
        let referenceId = cartItem.variant_id;
        
        const quantity = cartItem.quantity;
        const price = cartItem.price;
        const category = cartItem.product_type;
        const warrantyAlreadyInCart = ExtendShopify.warrantyAlreadyInCart(referenceId, cart.items) || ExtendShopify.warrantyAlreadyInCart(referenceId.toString(), cart.items);
        
        let anchor = lineItemElement.querySelector(cartSelectors.offerAnchor);
        
        if (!anchor) {
            throw new ExtendError(`Offer anchor element on line ${index} not found with selector ${cartSelectors.offerAnchor}`);
        }
        
        let extendOffer = lineItemElement.querySelector(cartOfferTag);
        
        // If there's already an offer element, check that the properties match what we are trying to create
        // If they do not match, or the warranty is already in cart, remove the offer
        if (extendOffer) {
            if (extendOffer.params.referenceId !== referenceId ||
                extendOffer.params.quantity !== quantity ||
                extendOffer.params.price !== price ||
                extendOffer.params.category !== category ||
                warrantyAlreadyInCart
            ) {
                extendOffer.remove();
                // If they do match and the warranty is not already in the cart, do not create a new offer
            } else {
                return;
            }
            // If there is no offer element, but the warranty is already in cart, do not create a new offer
        } else if (warrantyAlreadyInCart) {
            return;
        }
        
        let newExtendOffer = new ExtendCartOffer(referenceId, category, price, quantity, type);
        
        anchor.append(newExtendOffer); // append, prepend, after, before
    }
    
    function styleWarrantyLineItem(lineItemElement, index) {
        const title = lineItemElement.querySelector(cartSelectors.cartRowItemTitle);
        title.style.pointerEvents = 'none';
        title.innerText = 'Extend Protection Plan';
        
        const image = lineItemElement.querySelector(cartSelectors.cartRowItemImage);
        
        if (image) {
            image.style.pointerEvents = 'none';
        } else {
            console.error(`EXTEND: Line item image element on line ${index} not found with selector ${cartSelectors.cartRowItemImage}`)
        }
        
        const warrantyMetadata = lineItemElement.querySelectorAll(cartSelectors.warrantyOriginalMeta);
        
        if (warrantyMetadata?.length) {
            warrantyMetadata.forEach(each => {
                const property = each.innerText.trim().toLowerCase();
                
                if (!property.startsWith('product') && !property.startsWith('term')) each.remove();
                else {
                    each.classList.add('extend-warranty-info');
                }
            });
        }
        
        if (cartSelectors.quantityWrapper?.length && lineItemElement.querySelector(cartSelectors.quantityWrapper)) {
            lineItemElement.querySelectorAll(cartSelectors.quantityWrapper).forEach((each) => {
                each.style.opacity = '75%';
                each.style.pointerEvents = 'none';
            });
        }
        
    }
    
    function formatLineItems() {
        let cartContainer = document.querySelector(cartSelectors.cartContainer);
        
        if (!cartContainer) {
            throw new ExtendError(`Invalid cart container selector: ${cartSelectors.cartContainer}`);
        }
        
        cartContainer.querySelectorAll(cartSelectors.cartRowItem).forEach((lineItemElement, index) => {
            let title = lineItemElement.querySelector(cartSelectors.cartRowItemTitle);
            
            if (!title) {
                throw new ExtendError('Line item title not found');
            }
            
            let lowerCaseTitle = title.innerText.toLowerCase();
            
            if (lowerCaseTitle.includes('extend protection')) {
                styleWarrantyLineItem(lineItemElement, index);
            } else {
                createWarrantyOffer(lineItemElement, index);
            }
            
        });
    }
    
    function normalizeItems(callback) {
        if (SPEnabled) {
            ExtendShopify.updateExtendLineItems({
                balanceCart: cartBalancingEnabled,
                isSPSupported: cartSPEnabled,
                callback
            });
        } else {
            let normalizationOpts = {
                balance: cartBalancingEnabled
            }
            ExtendShopify.normalizeCart(normalizationOpts, callback);
        }
    }
    
    function refreshCart() {
        if (type === 'side') {
            document.dispatchEvent(new Event('cart:refresh'));
            setTimeout(init, 250);
        } else if (type === 'main') {
            window.location.reload();
        } else {
            window.location.reload();
        }
    }
    
    function verifyCartOffers() {
        verifyExtend();
        
        let error = '';
        if (typeof cartSelectors == 'undefined' || !cartSelectors) error += `cartSelectors is empty\n`;
        
        if (typeof type == 'undefined' || !type) error += `Cart type not defined\n`;
        
        if (error.length > 0) {
            throw new ExtendError(`Cannot initialize cart offers due to following errors:\n${error}`);
        }
    }
    
    function initEventListeners() {
        document.addEventListener('cart-drawer:open', init);
        document.addEventListener('cart:item-added', init);    
        document.addEventListener('line-item:change:end', init);
        document.addEventListener('extend.plan-added', refreshCart);
        
        document.addEventListener('extend.cart-refreshed', () => {
            setTimeout(() => {
                init()
            }, 250);
        })
        
        
        isInit = true;
    }
    
    // ! ||--------------------------------------------------------------------------------||
    // ! ||                                  Checkout Plus                                 ||
    // ! ||--------------------------------------------------------------------------------||
    
    const checkoutPlusSelectors = {
        checkoutButton: 'button[name="checkout"]',
        offerContainer: type == 'main' ? '.proceed-to-checkout' : '.cart-drawer-buttons form',
        checkoutPlusButtonParent: ''
    }
    
    function initCheckoutPlus(cart) {
        let checkoutPlusOffer = document.querySelector('extend-checkout-plus');
        if (checkoutPlusOffer) {
            checkoutPlusOffer.update(cart);
        } else {
            // Failsafe if we can not find the default checkout button
            if(!document.querySelector(checkoutPlusSelectors.checkoutButton) || !document.querySelector(checkoutPlusSelectors.offerContainer)) {
                throw new ExtendError('Could not find default checkout button or checkout plus offer container');
            }
            
            ExtendCheckoutPlus.getQuote(cart).then((quote) => {
                const defaultCheckoutButton = document.querySelector(checkoutPlusSelectors.checkoutButton);
                
                checkoutPlusOffer = new ExtendCheckoutPlusOffer(defaultCheckoutButton, cart, quote);
                if (checkoutPlusOffer.currentQuote && checkoutPlusOffer.currentQuote.premium > 0) {
                    document.querySelector(checkoutPlusSelectors.offerContainer).prepend(checkoutPlusOffer);
                }
            });
        }
    }
    
    function init() {
        verifyCartOffers();
        
        try {
            if (!/cart/.test(window.location.pathname) && !sideCartOfferEnabled) {
                throw new ExtendError('Cannot initialize cart offers - not a cart page');
            }
        } catch (err) {
            console.warn(err.message);
            return;
        }
        
        if (!isInit) initEventListeners();
        
        normalizeItems((err, data) => {
            cart = data?.cart;
            if (err) {
                throw new ExtendError(err.message);
            }
            
            if (data?.updates) {
                refreshCart();
            } else if (cart.items.length > 0) {
                initCheckoutPlus(data.cart);
                formatLineItems();
            }
        });
    }
    
    // Remove any SP plans in cart
    (() => {
        getCart().then(cart => {
            for (let item of cart.items) {
                if (item.vendor === 'Extend' && 
                    (item.sku === 'Extend Shipping Protection Plan' || item.title.includes('Shipping Protection'))
                ) {
                    return item.variant_id + ""
                }
            }
            return null
        }).then(variantId => {
            if (!variantId) return false

            return fetch(theme.routes.cart_change_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: 0
                })
            })
        }).then((cartUpdated) => {
            if (cartUpdated) refreshCart()
        })
    })()

    return init
})();

// ! ||--------------------------------------------------------------------------------||
// ! ||                                      Utils                                     ||
// ! ||--------------------------------------------------------------------------------||
class ExtendError extends Error {
    constructor(message) {
        super(message);
    }
}

function getConfiguration() {
    return {
        currency: 'USD',
        writeLogsEnabled: false,
        pdpOfferEnabled: true,
        offerModalEnabled: true,
        cartOfferEnabled: true,
        sideCartOfferEnabled: true,
        cartBalancingEnabled: true,
        aftermarketModalEnabled: true,
        atcOfferEnabled: true,
        quickViewOfferEnabled: true,
        quickViewModalOfferEnabled: true,
        cartSPEnabled: false,
        SPEnabled: true,
    };
}

function verifyExtend() {
    const propertiesToCheck = [
        'window.Extend',
        'window.ExtendShopify',
        'window.Shopify',
        'window.Shopify.currency.active'
    ];
    
    function checkPropertyExists(path) {
        return path.split('.').reduce((obj, prop) => obj && obj[prop], window) !== undefined;
    }
    
    let errors = propertiesToCheck.filter(prop => !checkPropertyExists(prop));
    
    // Check for currency mismatch
    if (window.Shopify?.currency?.active !== getConfiguration().currency) {
        errors.push('Active currency does not match configured currency');
    }
    
    if (errors.length) {
        let message = "The following value(s) are null, undefined, or false:\n";
        errors.forEach((error) => {
            message += `\t${error}\n`;
        });
        throw new ExtendError(message);
    }
}

function initAftermarket() {
    try {
        verifyExtend();
        
        // Get params from URL
        const params = (new URL(document.location)).searchParams;
        
        // Check if leadToken or leadtoken is in the URL
        let leadToken = params.get('leadToken')
        ? params.get('leadToken')
        : params.get('leadtoken');
        
        if (leadToken) {
            Extend.aftermarketModal.open({
                leadToken: leadToken,
                onClose: function (plan, product, quantity) {
                    if (plan && product) {
                        ExtendShopify.addPlanToCart({
                            plan: plan,
                            product: product,
                            leadToken: leadToken,
                            quantity: quantity || 1
                        }, function () {
                            location = '/cart'
                        })
                    }
                }
            });
        }
    } catch (error) {
        throw new ExtendError( error.message);
    }
}

function getCart() {
    return fetch('/cart.js', {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then(e => e.json());
}

function fetchProduct(handle) {
    return fetch(`/products/${handle}`, {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    }).then(e => e.json())
    .then(response => response.product)
}

// Integration init
window.addEventListener('DOMContentLoaded', () => {
    try {
        const storeId = '631fc415-1aa2-402c-8939-9734bf5a7f3e';
        const environment = 'production';
        
        window.Extend.config({ storeId, environment});
        
        const config = getConfiguration();
        
        if (config.aftermarketModalEnabled)
            initAftermarket();
        
        if (config.atcOfferEnabled || config.offerModalEnabled || config.pdpOfferEnabled)
            initProductOffer();
        //
        if (config.quickViewOfferEnabled) 
            initQuickView();
        
        if (config.cartOfferEnabled || config.cartSPEnabled || config.sideCartOfferEnabled)
            initCartOffer();
        
    } catch (err) {
        if (sessionStorage.getItem('extend.debug'))
            console.error(err);
    }
});